import { render, staticRenderFns } from "./StaffInputList.vue?vue&type=template&id=33d0b7f6&scoped=true"
import script from "./StaffInputList.vue?vue&type=script&lang=js"
export * from "./StaffInputList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d0b7f6",
  null
  
)

export default component.exports